// Suppliers.js
import React from "react";
import TierEntity from "../Tiers/TierEntity";

const Suppliers = () => {
    return <TierEntity title="Fournisseurs" endpoint="Suppliers" />;
};

export default Suppliers;
